"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.APFilterMulti = void 0;
var Button_1 = __importDefault(require("@material-ui/core/Button"));
var Checkbox_1 = __importDefault(require("@material-ui/core/Checkbox"));
var FormControlLabel_1 = __importDefault(require("@material-ui/core/FormControlLabel"));
var react_1 = __importStar(require("react"));
var Common_1 = require("../../layout/Common");
var APText_1 = require("../../elements/APText");
var APFlex_1 = require("../../layout/APFlex");
var APFilterMenu_1 = require("./APFilterMenu");
var __1 = require("../..");
function APFilterMulti(_a) {
    var _b;
    var header = _a.header, options = _a.options, onChange = _a.onChange, initialValue = _a.initialValue;
    var _c = react_1.useState(initialValue !== null && initialValue !== void 0 ? initialValue : []), selected = _c[0], setSelected = _c[1];
    var _d = react_1.useState(""), searchText = _d[0], setSearchText = _d[1];
    react_1.useEffect(function () {
        onChange(selected);
    }, [selected]);
    react_1.useEffect(function () {
        if (initialValue)
            setSelected(initialValue);
    }, [(_b = initialValue === null || initialValue === void 0 ? void 0 : initialValue.join(",")) !== null && _b !== void 0 ? _b : ""]);
    var majoritySelected = selected.length > options.length / 2;
    var filteredOptions = options
        .filter(function (option) {
        if (searchText.length > 0) {
            return option.label.toLowerCase().includes(searchText.toLowerCase()) || option.value.toLowerCase().includes(searchText.toLowerCase());
        }
        return true;
    });
    return react_1.default.createElement(APFlex_1.APColumn, { mainAxisSize: 'max', crossAxisAlignment: 'stretch' },
        react_1.default.createElement(APFlex_1.APRow, { mainAxisSize: "max", mainAxisAlignment: "spaceBetween", crossAxisAlignment: 'center' },
            react_1.default.createElement(APFilterMenu_1.HeaderItem, { text: header }),
            react_1.default.createElement(Common_1.APSizedBox, { width: "20px" }),
            react_1.default.createElement(Button_1.default, { onClick: function () {
                    if (!majoritySelected) {
                        setSelected(__spreadArrays(options.map(function (a) { return a.value; })));
                    }
                    else {
                        setSelected([]);
                    }
                }, size: "small", style: { color: "#888", fontWeight: 500, marginRight: "12px", fontSize: '12px' }, variant: "text" }, !majoritySelected ? "Select All" : "Remove All")),
        options.length > 7 ? react_1.default.createElement(__1.APDebounceText, { style: { marginLeft: "12px", marginRight: "12px", marginBottom: "6px", }, onChanged: function (v) { setSearchText(v); } }) : undefined,
        react_1.default.createElement(Common_1.APExpanded, null,
            react_1.default.createElement(__1.APVirtualList, { itemCount: filteredOptions.length, itemHeight: 36 }, function (_a) {
                var index = _a.index;
                var option = filteredOptions[index];
                return react_1.default.createElement(FormControlLabel_1.default, { style: { padding: "0 12px" }, key: index, value: option.value, checked: selected.includes(option.value), onChange: function (e, v) {
                        if (v) {
                            setSelected(__spreadArrays(selected, [option.value]));
                        }
                        else {
                            setSelected(selected.filter(function (e) { return option.value !== e; }));
                        }
                    }, control: react_1.default.createElement(Checkbox_1.default, { color: "primary", size: 'small' }), label: react_1.default.createElement(APText_1.APText, { variant: "normal", style: { fontWeight: 500, color: selected.includes(option.value) ? "#111" : "#555" } }, option.label) });
            })));
}
exports.APFilterMulti = APFilterMulti;
